import { connect } from 'react-redux';

/**
 * Suppress errors from wrongly guessed JS connected component type
 *
 * After update @types/react-redux to 7.1.24, some legacy JS component types went nuts,
 * throwing wrong missing properties errors on usages. I didn't find a better way
 * to fix these errors, so I solved it by suppressing guessed component types this way.
 *
 * @deprecated it should never be used with new typescript code
 */
export const connectAsAny: any = connect;
